var _globalThis$process, _globalThis$process$e;

var node_env = (_globalThis$process = globalThis.process) === null || _globalThis$process === void 0 ? void 0 : (_globalThis$process$e = _globalThis$process.env) === null || _globalThis$process$e === void 0 ? void 0 : _globalThis$process$e.NODE_ENV;
export default node_env && !node_env.toLowerCase().startsWith('prod');